var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('IntermediateHeader'),_c('div',{staticClass:"out-padd bg-pickl"},[_c('BrandVideo',{attrs:{"show-button":true}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }